module.exports = __webpack_public_path__ + "static/media/stop-circle.cbfc6115.svg";